
import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectMixin from '@/_mixins/project'
import { PROJECT_ACCESS_RULES_QUERY } from '@/views/Project/access/gql/queries.ts'
import { accessClient } from '@/apolloClient'
import { Days } from '@/views/Project/access/utils'
import AddButton from '@/_components/button/add/add.vue'
import { openDialog } from '@/_components/dialog/dialog'
import RuleDialog from '@/views/Project/access/ruleDialog.vue'
import { Project } from '@/views/Project/access/types'

export default {
    name: 'AccessSettingsRules',
    mixins: [ProjectMixin],
    components: {
        AddButton,
        AppToolbar,
    },
    data() {
        return {
            saveStatus: null as Maybe<'saved' | 'saving'>,
            project: null as Maybe<Project>,
            isFetching: false,
            allRulesForProject: [] as any[],
        }
    },
    computed: {
        days() {
            return Days
        },
        rules() {
            const projectRules: any = []
            this.allRulesForProject.forEach((rule) => {
                if (rule.intervals.length === 0) {
                    projectRules.push({
                        id: rule.id,
                        name: rule.name,
                        type: rule.type,
                        interval: {
                            days: [],
                            from: '00:00',
                            to: '00:00',
                            requiresPin: false,
                        },
                        _isFirstInterval: true,
                        _isLastInterval: true,
                        _canEdit: rule.type === 'REGULAR',
                    })
                } else {
                    rule.intervals.forEach((interval, index, items) => {
                        projectRules.push({
                            id: rule.id,
                            name: rule.name,
                            type: rule.type,
                            interval,
                            _isFirstInterval: index === 0,
                            _isLastInterval: index === items.length - 1,
                            _canEdit: rule.type === 'REGULAR',
                        })
                    })
                }
            })
            return projectRules
        },
    },
    methods: {
        async getRules() {
            const ruleQueryResult = await accessClient.query({
                query: PROJECT_ACCESS_RULES_QUERY,
                variables: {
                    projectId: this.currentProjectId,
                },
                fetchPolicy: 'network-only',
            })
            this.allRulesForProject = ruleQueryResult.data.allRulesForProject
            this.project = ruleQueryResult.data.project
        },
        async openRule(ruleItem: any) {
            if (!ruleItem._canEdit || !this.project.meta.can.manageAccessGroups) {
                return
            }

            const rule = this.allRulesForProject.find((rule) => rule.id === ruleItem.id)
            if (!rule) {
                return
            }

            const result = await openDialog(RuleDialog, { rule })

            if (result?.deletedAt) {
                this.allRulesForProject = this.allRulesForProject.filter(
                    (_rule) => _rule.id !== rule.id
                )
            } else if (result?.updatedRule) {
                this.allRulesForProject = this.allRulesForProject.map((_rule) => {
                    if (_rule.id === rule.id) {
                        return { ...result.updatedRule }
                    }
                    return _rule
                })
            }
        },
        async addNewRule() {
            const result = await openDialog(RuleDialog)

            if (result?.allRulesForProject) {
                this.allRulesForProject = [...result.allRulesForProject]
                this.allRulesForProject.sort((a, b) => a.name.localeCompare(b.name))
            }
        },
    },
    async mounted() {
        try {
            this.isFetching = true
            await this.getRules()
        } finally {
            this.isFetching = false
        }
    },
}
